<template>
  <div>
    <sidenav :orientation="orientation" :class="curClasses">
      <!-- Brand Top Ver -->
      <div class="app-brand demo">
        <span @click="onHomeClick" class="app-brand-logo demo bg-primary m-2 ml-3 mt-3 mb-3" :style="logoStyle">
          <appDefaultLogo v-if="!logoIcon" />
          <span v-else>
            <b-img class="logo-app-custom" :src="logoIcon" />
          </span>
        </span>
        <router-link to="/" class="app-brand-text sidenav-text font-weight-normal ml-2">{{
          appTitle
        }}</router-link>
        <a
          href="javascript:void(0)"
          class="layout-sidenav-toggle sidenav-link text-large ml-auto"
          @click="toggleSidenav()"
        >
          <i class="ion ion-md-menu align-middle"></i>
        </a>
      </div>

      <!-- Links -->
      <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
        <div
          class="w-100 trocar-empresa font-weight-semibold d-flex justify-content-between align-items-center mb-2 px-3"
          v-if="orientation !== 'horizontal'"
        >
          <div class="pt-2">{{ $store.state.user.info['empresa__nome'] }}</div>

          <div class="cursor-pointer" @click="modalTrocarEmpresa()" v-if="getIsMultiEmpresa()">
            <icon-svg :width="32" :height="32" iconColor="#DCDCDE" :iconName="$t('Trocar de Empresa')">
              <icon-swap />
            </icon-svg>
          </div>
        </div>

        <!-- <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'" /> -->
        <!-- Dashboard -->
        <!-- <sidenav-router-link icon="ion ion-md-speedometer" to="/dashboard" :exact="true">{{
          $t('Dashboard')
        }}</sidenav-router-link> -->

        <template v-for="(sn, index) in sideNav" v-if="orientation == 'horizontal'">
          <template v-for="(menu, index) in sn.menuItens">
            <sidenav-menu :icon="'ion ' + menu.icon" :exact="true">
              <template slot="link-text">{{ $t(menu.nome) }}</template>

              <div v-for="(item, index) in menu.menuItens" v-bind:key="`${item.permissao}-${index}`">
                <!-- divider -->
                <sidenav-divider class="mb-1" v-if="item.divider" />
                <!-- link -->
                <sidenav-router-link :to="item.path" :exact="true" v-if="item.path">
                  {{ $t(item.nome) }}
                </sidenav-router-link>
                <!-- submenu -->
                <sidenav-menu v-if="item.menuItens">
                  <template slot="link-text">{{ $t(item.nome) }}</template>
                  <div v-for="submenu in item.menuItens" :key="`${submenu.permissao}-${submenu.nome}`">
                    <sidenav-router-link :to="submenu.path" :exact="true">
                      {{ $t(submenu.nome) }}</sidenav-router-link
                    >
                  </div>
                </sidenav-menu>
              </div>
            </sidenav-menu>
          </template>
        </template>

        <!--  -->
        <div
          v-for="(sn, index) in sideNav"
          style="width: 100%"
          :key="`${sn.nome}-${index}`"
          v-if="orientation !== 'horizontal'"
        >
          <sidenav-divider class="mb-1" />
          <sidenav-header class="small font-weight-semibold">{{ $t(sn.nome) }}</sidenav-header>
          <sidenav-menu
            :icon="'ion ' + menu.icon"
            :exact="true"
            v-for="(menu, index) in sn.menuItens"
            :key="`${index}-${menu.nome}`"
          >
            <template slot="link-text">{{ $t(menu.nome) }}</template>
            <div v-for="(item, index) in menu.menuItens" :key="`${item.permissao}-${index}`">
              <!-- divider -->
              <sidenav-divider class="mb-1" v-if="item.divider" />
              <!-- link -->
              <sidenav-router-link :to="item.path" :exact="true" v-if="item.path">
                {{ $t(item.nome) }}
              </sidenav-router-link>
              <!-- submenu -->
              <sidenav-menu v-else>
                <template slot="link-text">{{ $t(item.nome) }}</template>
                <sidenav-router-link
                  v-for="submenu in item.menuItens"
                  :key="`${submenu.permissao}-${submenu.nome}`"
                  :to="submenu.path"
                  :exact="true"
                >
                  {{ $t(submenu.nome) }}
                </sidenav-router-link>
              </sidenav-menu>
            </div>
          </sidenav-menu>
        </div>

        <!-- Logout -->
        <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>
        <div class="sidenav-item logout" @click="logout()">
          <span class="sidenav-link">
            <i class="sidenav-icon ion ion-md-log-out"></i>
            <div>{{ $t('Sair do Sistema') }}</div>
          </span>
        </div>
        <sidenav-divider v-if="currentDate" class="mb-1" />
        <div class="sidenav-item" v-if="currentDate && orientation !== 'horizontal'">
          <b-row>
            <b-col class="d-flex justify-content-center">
              <div class="text-secondary hour-info">
                <small>{{ currentDate }} ({{ currentTimezone }})</small>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </sidenav>
    <modal-trocar-empresa :openModal="openModal" @closeModal="onCloseModalTrocarEmpresa" />
  </div>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav';
import ModalTrocarEmpresa from '@/components/views/menu/ModalTrocarEmpresa.vue';
import { getMenuOptions } from '@/components/views/menu/sideMenuOptions';
import IconSwap from '@/components/helpers/IconSwap.vue';
import appDefaultLogo from '@/components/helpers/appDefaultLogo';

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    appDefaultLogo,
    SidenavBlock,
    SidenavDivider,
    'modal-trocar-empresa': ModalTrocarEmpresa,
    IconSwap
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  data() {
    return {
      sideNav: [],
      openModal: false,
      currentDate: '',
      currentTimezone: ''
    };
  },

  async created() {
    const filterMenuByPermission = (arr) => {
      return arr.reduce((acc, item) => {
        const newItem = item;

        if (item?.menuItens) {
          newItem.menuItens = filterMenuByPermission(item.menuItens);
        }

        if (
          (!newItem?.menuItens && this.$util.checarAcao(newItem?.permissao)) ||
          (newItem?.menuItens && newItem?.menuItens?.length > 0)
        ) {
          if (newItem?.requireMfa && !localStorage.getItem('mfa-accomplished')) {
            return acc;
          }

          if (newItem?.requiredRoot && !this.getUserIsRoot()) {
            return acc;
          }

          if (newItem?.requiredBi && !this.getUserIsBi()) {
            return acc;
          }

          this.$util.validarPermissaoGestor(newItem) && acc.push(newItem);
        }

        return acc;
      }, []);
    };

    this.sideNav = filterMenuByPermission([...getMenuOptions()]);
    this.sideNav = await this.loadDashboards(this.$util.getObjectRaw(this.sideNav));
    this.setTime();
  },

  computed: {
    logoIcon() {
      return process.env.VUE_APP_LOGO;
    },
    logoStyle() {
      return `background-color: #${process.env.VUE_APP_LOGO_COLOR} !important;`;
    },
    appTitle() {
      return process.env.VUE_APP_TITLE || 'Atena';
    },
    perfilMetabaseDashboard() {
      if (this.$store?.state?.user?.info?.perfis) {
        let perfis = JSON.parse(this.$store.state.user?.info.perfis);
        return perfis?.id_perfil_metabase_dashboard || null;
      }

      return null;
    },
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === 'horizontal' &&
        (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)
      ) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '');
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0')
      );
    }
  },

  methods: {
    setTime() {
      this.currentTimezone =
        localStorage.getItem('userTimezone') || Intl.DateTimeFormat().resolvedOptions().timeZone;
      setInterval(() => {
        this.currentDate = new Date().toLocaleString();
      }, 1000);
    },
    // Loads dashboards items from user profile
    async loadDashboards(sideNav) {
      try {
        let dashboardsGroupKey = 'Análise';
        let dashboardsGroup = sideNav.find((item) => item.nome === dashboardsGroupKey);
        let perfilId = this.perfilMetabaseDashboard;

        if (!dashboardsGroup && perfilId) {
          sideNav.splice(1, 0, {
            nome: 'Análise',
            menuItens: []
          });
          dashboardsGroup = sideNav.find((item) => item.nome === dashboardsGroupKey);
        }

        if (!perfilId || !dashboardsGroup) return sideNav;

        let perfilResponse = await this.$atenaList.getCommon('perfil_metabase_dashboard', {
          filter: `id = ${perfilId}`
        });

        if (perfilResponse?.data?.length) {
          let cfg = perfilResponse?.data[0]?.configuracao ? JSON.parse(perfilResponse?.data[0]?.configuracao) : {};
          if (cfg?.dashboards?.length) {
            let menuItens = [];
            for (const dashboardId of cfg.dashboards) {
              let dashboardResponse = await this.$atenaList.getCommon('metabase_dashboard', {
                filter: `id = ${dashboardId}`
              });
              if (dashboardResponse?.data?.length) {
                menuItens.push({
                  path: `/dashboardMetabase?dashboardId=${dashboardResponse?.data[0]?.id}`,
                  nome: dashboardResponse?.data[0]?.nome || 'Dashboard',
                  permissao: true
                });
              }
            }
            dashboardsGroup.menuItens.unshift({
              nome: 'Dashboards',
              path: '/dashboard',
              icon: 'ion-md-pie',
              menuItens: menuItens
            });
          }
        }
      } catch (error) {
        console.log(error);
      }

      return sideNav;
    },
    onHomeClick() {
      this.$router.replace('/');
    },

    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal';
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    async logout() {
      await this.$auth.logout();
      this.$router.replace('/');
    },
    getIsMultiEmpresa() {
      return this.$store.state.user.info.multi_empresa;
    },
    getUserIsRoot() {
      return this.$store.state.user.info.root;
    },
    getUserIsBi() {
      return this.$store?.state?.user?.info?.usuario_bi == true;
    },
    modalTrocarEmpresa() {
      if (this.layoutHelpers.isMobileDevice()) this.toggleSidenav();
      if (this.getIsMultiEmpresa()) {
        this.openModal = true;
      }
    },
    onCloseModalTrocarEmpresa() {
      this.openModal = false;
    }
  }
};
</script>

<style scoped>
.logout {
  cursor: pointer !important;
}
.sidenav-header {
  text-transform: uppercase !important;
}
.trocar-empresa div,
.trocar-empresa i {
  text-transform: uppercase !important;
  color: #fff !important;
}

.btn-circle.btn-xs {
  width: 27px;
  height: 27px;
  padding: 4px 0px;
  border-radius: 15px;
  font-size: 12px;
  text-align: center;
}
.logo-app-custom {
  width: 27px !important;
  height: 27px !important;
}
.hour-info {
  font-size: 11px !important;
}
</style>
